module.exports = __webpack_public_path__ + "static/media/pycs_04.90d30b2d.gif";